import { createAction } from '@reduxjs/toolkit';
import type { CompData } from '../../RecordingSessionDataGrid/types';
import type { DraftRecordingSession, EpisodeData, Filter, SelectInfoItem, TakeGroup } from '../types';

export const resetState = createAction('resetState');

export const setDraftSession = createAction<DraftRecordingSession>('setDraftSession');
export const setIsDraft = createAction<boolean>('setIsDraft');

// Filter options
export const setFilter = createAction<Filter>('setFilter');
export const setSeasonOptions = createAction<Record<string, string>>('setSeasonOptions');
export const setEpisodeOptions = createAction<Record<string, string>>('setEpisodeOptions');
export const setCharacterOptions = createAction<Record<string, string>>('setCharacterOptions');

// Takes and comps
export const setEpisodeData = createAction<EpisodeData>('setEpisodeData');
export const setComps = createAction<CompData[]>('setComps');
export const setTakeGroups = createAction<TakeGroup[]>('setTakeGroups');
export const setSelectInfos = createAction<SelectInfoItem[]>('setSelectInfos');

export const toggleScriptView = createAction('toggleScriptView');
export const toggleCompTextExpanded = createAction<string>('toggleCompTextExpanded');
export const setSubTakeIdToFocus = createAction<string | undefined>('setTakeIdToFocus');

export const setTakeCharacterIds = createAction<string[]>('setTakeCharacterIds');
export const setTakeRecordingOrder = createAction<'ByCharacter' | 'Chronologically'>('setTakeRecordingOrder');
export const setLineRevisionChains = createAction<Record<string, string>>('setLineRevisionChains');